/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { CellsResponseDataDeprecated } from "./CellsResponseDataDeprecated";
export const CellsResponseDeprecated = core.serialization.object({
    data: CellsResponseDataDeprecated,
});
